/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M2.5176 3.9482A.5748.5748 0 0 0 2 4.5202v6.0395C2 16.7564 6.0647 22.2194 12 24c5.9354-1.7806 10-7.2436 10-13.4403V4.5202a.5748.5748 0 0 0-.5176-.572A17.243 17.243 0 0 1 13.3096.9167L12 0l-1.3096.9167a17.2434 17.2434 0 0 1-8.1728 3.0315Zm15.0127 5.5821a.75.75 0 0 0-1.0606-1.0606L11 13.9393l-3.4697-3.4696a.75.75 0 0 0-1.0606 1.0606L11 16.0607l6.5303-6.5304Z"
    clipRule="evenodd"
  />,
  'VerifiedFilled'
);
